module.exports = __webpack_public_path__ + "6492be85b3338e573fa6a5ef60f6b6c4.svg";